// extracted by mini-css-extract-plugin
export default {"mainContainer":"OurServices_mainContainer__Qn-pO","cardsParent":"OurServices_cardsParent__vyOmN","card":"OurServices_card__WGcWL"};